import {
	GridItem,
	SimpleGrid,
	Stack,
	Text,
} from '@chakra-ui/react';

import FooterLinkColumn from './FooterLinkColumn/FooterLinkColumn';

type FooterProps = {
	footerLinks: {
		heading: string;
		links:   {
			href:     string;
			label:    string;
			isNewTab: boolean;
		}[];
	}[];
};

const Footer = ({ footerLinks }: FooterProps) => {
	const year = new Date().getFullYear();

	return (
		<Stack
			alignItems={'center'}
			bg={'#3B2F2F'}
			color={'whiteAlpha.950'}
			gap={8}
			p={8}
		>
			<SimpleGrid
				columns={{
					base: 1,
					md:   2,
					lg:   4,
				}}
				gap={8}
				justifyContent={'space-evenly'}
				w={'100%'}
			>
				{footerLinks.map(column => (
					<GridItem key={column.heading}>
						<FooterLinkColumn heading={column.heading} links={column.links} />
					</GridItem>
				))}
			</SimpleGrid>
			<Text textStyle={'p3'}>
				© {year} Vision Protect Thailand. All rights reserved.
			</Text>
		</Stack>
	);
};

export default Footer;
